import { useEffect } from 'react';
import { IFormConfig } from 'js/components/common/Form/types';

import * as helpers from '../helpers';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';

export const useFieldsAndRules = ({ formConfig, formName }: { formConfig: IFormConfig; formName: string }) => {
    const dispatch = useDynamicReducerDispatch();

    useEffect(() => {
        if (!formConfig) {
            return;
        }

        const { formFields, formRules, id } = formConfig;

        dispatch(actions.setFormFieldsAndRules({
            formName,
            formId: id,
            formFields: helpers.getFormFields(formFields),
            formRules: helpers.getFormRules(formRules, formFields)
        }));
    }, [dispatch, formConfig, formName]);

    return null;
};
